import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

export type ParamaterEntryType = {
  name: string;
  value: string | number | boolean | null | undefined;
};

export type AnchorTagType = {
  value: string | number | null | undefined;
};

export type SectionType = {
  value: string | number | null | undefined;
};

export default class URLGenerator {
  private url: string = '';
  private anchorTag: string | number | null | undefined = null;
  private section: string | number | null | undefined = null;
  private paramEntries: ParamaterEntryType[] = [];

  public constructor(url: string) {
    this.url = url;
  }

  public addParameter({ name, value }: ParamaterEntryType) {
    this.paramEntries.push({ name, value });
  }

  public addAnchorTag({ value }: AnchorTagType) {
    this.anchorTag = value;
  }

  public addSection({ value }: SectionType) {
    this.section = (value && value.toString().startsWith('/')) ? value : `/${value}`;
  }

  public generateURL(): string {
    let baseUrl = `${this.url}${isEmpty(this.paramEntries) ? '' : '?'}`;

    if (!isEmpty(this.paramEntries)) {
      this.paramEntries.forEach((item, index) => {
        if (!isNil(item.value)) {
          baseUrl = `${baseUrl}${item.name}=${item.value}${index !== this.paramEntries.length - 1 ? '&' : ''}`;
        }
      });
    }

    if (!isNil(this.anchorTag)) {
      if (baseUrl.includes('#')) {
        baseUrl = baseUrl.replace(/#.*$/, `#${this.anchorTag}`);
      } else {
        baseUrl = `${baseUrl}#${this.anchorTag}`;
      }
    }

  if (!isNil(this.section)) {
        baseUrl = `${baseUrl}${this.section}`;
  }

    return baseUrl;
  }
}
